$(function(){

})

checkVariantDropdown = (vr) => {
  var show = true;
  $('.all_order_variant_id').children().each(function(){
    var _id = $(this).val();
    if (vr.id == _id){
      show = false;
    }
  })
  if (show) {
    $('.purchased').hide();
    $('.js-addtoCart').show();
  }
  else{
    $('.purchased').show();
    $('.js-addtoCart').hide();
  }

}
